import './App.css';
import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ClientAuthProvider } from './Context/ClientAuthContext';

// Components
import NavAuth from './Components/NavAuth';
import SplashScreen from './Components/SplashScreen';

// Pages existantes (employés/admin)
import Register from './Components/Register';
import Login from './Components/Login';
import ListUser from './Components/ListUser';
import UpdateUser from './Components/UpdateUser';
import UpdateProfil from './Components/UpdateProfil';
import Welcome from './Components/Welcome';

// Nouvelles pages client
import ClientRegister from './pages/ClientRegister';
import ClientLogin from './pages/ClientLogin';
import ScanPoints from './pages/ScanPoints';
import MyPoints from './pages/MyPoints';
import Rewards from './pages/Rewards';
import PointsHistory from './pages/PointsHistory';
import ClientProfile from './pages/ClientProfile';
import HelpCenter from './pages/HelpCenter';
import Wallet from './pages/Wallet';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Pages admin
import ManageRewards from './pages/admin/ManageRewards';
import PointsReport from './pages/admin/PointsReport';
import ManageOffers from './pages/admin/ManageOffers';

// Route protégée pour clients
const ClientRoute = ({ children }) => {
  const isClientAuthenticated = localStorage.getItem('clientToken');
  return isClientAuthenticated ? children : <Navigate to="/login-client" />;
};

// Route protégée pour admin
const AdminRoute = ({ children }) => {
  const isAdmin = localStorage.getItem('token');
  return isAdmin ? children : <Navigate to="/Login" />;
};

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <>
      {showSplash && <SplashScreen onFinish={() => setShowSplash(false)} />}
      <ClientAuthProvider>
        <div className="App">


          <div className="main-content">
            <Routes>
              {/* Routes publiques */}
              <Route path="/" element={<NavAuth />} />
              <Route path="/Welcome" element={<Welcome />} />
              <Route path="/register-client" element={<ClientRegister />} />
              <Route path="/login-client" element={<ClientLogin />} />
              <Route path="/Login" element={<Login />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />

              {/* Routes client (protégées) */}
              <Route path="/scan-points" element={
                <ClientRoute>
                  <ScanPoints />
                </ClientRoute>
              } />

              <Route path="/my-points" element={
                <ClientRoute>
                  <MyPoints />
                </ClientRoute>
              } />

              <Route path="/rewards" element={
                <ClientRoute>
                  <Rewards />
                </ClientRoute>
              } />

              <Route path="/history" element={
                <ClientRoute>
                  <PointsHistory />
                </ClientRoute>
              } />

              <Route path="/profile" element={
                <ClientRoute>
                  <ClientProfile />
                </ClientRoute>
              } />

              <Route path="/wallet" element={
                <ClientRoute>
                  <Wallet />
                </ClientRoute>
              } />

              <Route path="/update-profil" element={
                <ClientRoute>
                  <UpdateProfil />
                </ClientRoute>
              } />

              <Route path="/help-center" element={
                <ClientRoute>
                  <HelpCenter />
                </ClientRoute>
              } />

              {/* Routes admin existantes */}
              <Route path="/Register" element={
                <AdminRoute>
                  <Register />
                </AdminRoute>
              } />

              <Route path="/AllUser" element={
                <AdminRoute>
                  <ListUser />
                </AdminRoute>
              } />

              <Route path="/UpdateUser/:id" element={
                <AdminRoute>
                  <UpdateUser />
                </AdminRoute>
              } />

              <Route path="/UpdateProfil" element={
                <AdminRoute>
                  <UpdateProfil />
                </AdminRoute>
              } />

              {/* Nouvelles routes admin */}
              <Route path="/manage-rewards" element={
                <AdminRoute>
                  <ManageRewards />
                </AdminRoute>
              } />

              <Route path="/points-report" element={
                <AdminRoute>
                  <PointsReport />
                </AdminRoute>
              } />

              <Route path="/manage-offers" element={
                <AdminRoute>
                  <ManageOffers />
                </AdminRoute>
              } />

              {/* Route par défaut */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </div>
      </ClientAuthProvider>
    </>
  );
}

export default App;